export interface Mahalle {
  slug: string;
  name: string;
  fullName: string;
}

export interface Bolge {
  slug: string;
  name: string;
  title: string;
  metaTitle: string;
  metaDesc: string;
  desc: string;
  longDesc: string;
  img: string;
  mapEmbed: string;
  mahalleler: Mahalle[];
}

export const bolgeData: Bolge[] = [
  {
    slug: 'beylikduzu-cilingir',
    name: 'Beylikdüzü',
    title: 'Beylikdüzü Çilingir',
    metaTitle: 'Beylikdüzü Çilingir | Alfa Çilingir 7/24 Acil - 0541 624 79 82',
    metaDesc: 'Beylikdüzü çilingir hizmeti. Acil kapı açma, kilit değiştirme, çelik kapı açma. 7/24 hizmet, 15 dakikada yanınızda. Hemen arayın: 0541 624 79 82',
    desc: 'Beylikdüzü\'nün tüm mahalle ve semtlerinde 7/24 profesyonel çilingir hizmeti.',
    longDesc: 'Alfa Çilingir olarak Beylikdüzü\'nün tüm mahalle ve semtlerinde 7/24 kesintisiz çilingir hizmeti sunuyoruz. Acil kapı açma, kilit değiştirme, çelik kapı açma, oto çilingir ve kasa açma konularında uzman ekibimiz ortalama 15 dakikada adresinizde olur. Beylikdüzü\'nde kapınız kilitli kaldıysa, anahtarınızı kaybettiyseniz veya kilit değiştirmek istiyorsanız hemen arayın.',
    img: 'https://readdy.ai/api/search-image?query=Beylikduzu%20Istanbul%20modern%20residential%20neighborhood%2C%20wide%20streets%2C%20apartment%20buildings%2C%20urban%20district%20Turkey%2C%20daytime%20clear%20sky%2C%20professional%20photo&width=1200&height=600&seq=blp001&orientation=landscape',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48084.0!2d28.64!3d41.00!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b55f5e5e5e5e5e%3A0x0!2sBeylikd%C3%BCz%C3%BC%2C+%C4%B0stanbul!5e0!3m2!1str!2str!4v1700000000010!5m2!1str!2str',
    mahalleler: [
      { slug: 'adnan-kahveci', name: 'Adnan Kahveci', fullName: 'Adnan Kahveci Mahallesi' },
      { slug: 'baris', name: 'Barış', fullName: 'Barış Mahallesi' },
      { slug: 'buyuksehir', name: 'Büyükşehir', fullName: 'Büyükşehir Mahallesi' },
      { slug: 'cumhuriyet', name: 'Cumhuriyet', fullName: 'Cumhuriyet Mahallesi' },
      { slug: 'dereagzi', name: 'Dereağzı', fullName: 'Dereağzı Mahallesi' },
      { slug: 'gurpinar', name: 'Gürpınar', fullName: 'Gürpınar Mahallesi' },
      { slug: 'kavakli', name: 'Kavaklı', fullName: 'Kavaklı Mahallesi' },
      { slug: 'marmara', name: 'Marmara', fullName: 'Marmara Mahallesi' },
      { slug: 'sahil', name: 'Sahil', fullName: 'Sahil Mahallesi' },
      { slug: 'yakuplu', name: 'Yakuplu', fullName: 'Yakuplu Mahallesi' },
      { slug: 'yesilova', name: 'Yeşilova', fullName: 'Yeşilova Mahallesi' },
      { slug: 'ataturk', name: 'Atatürk', fullName: 'Atatürk Mahallesi' },
      { slug: 'fatih', name: 'Fatih', fullName: 'Fatih Mahallesi' },
      { slug: 'guzelyurt', name: 'Güzelyurt', fullName: 'Güzelyurt Mahallesi' },
      { slug: 'haramidere', name: 'Haramidere', fullName: 'Haramidere Mahallesi' },
      { slug: 'kucukcekmece-siniri', name: 'Mimarsinan', fullName: 'Mimarsinan Mahallesi' },
    ],
  },
  {
    slug: 'esenyurt-cilingir',
    name: 'Esenyurt',
    title: 'Esenyurt Çilingir',
    metaTitle: 'Esenyurt Çilingir | Alfa Çilingir 7/24 Acil - 0541 624 79 82',
    metaDesc: 'Esenyurt çilingir hizmeti. Acil kapı açma, kilit değiştirme, çelik kapı açma. 7/24 hizmet, 15 dakikada yanınızda. Hemen arayın: 0541 624 79 82',
    desc: 'Esenyurt\'un tüm mahalle ve semtlerinde 7/24 hızlı çilingir hizmeti.',
    longDesc: 'Alfa Çilingir olarak Esenyurt\'un yoğun nüfuslu tüm mahallelerinde 7/24 profesyonel çilingir hizmeti sunuyoruz. Esenyurt\'ta acil kapı açma, kilit değiştirme, çelik kapı açma ve oto çilingir hizmetleri için uzman ekibimiz her an hazır. Çağrı aldıktan sonra ortalama 15 dakikada adresinizde oluyoruz.',
    img: 'https://readdy.ai/api/search-image?query=Esenyurt%20Istanbul%20dense%20urban%20residential%20area%2C%20high%20rise%20apartment%20buildings%2C%20busy%20streets%2C%20Turkey%20urban%20district%2C%20aerial%20view&width=1200&height=600&seq=blp002&orientation=landscape',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48084.0!2d28.67!3d41.02!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b55f5e5e5e5e5e%3A0x0!2sEsenyurt%2C+%C4%B0stanbul!5e0!3m2!1str!2str!4v1700000000011!5m2!1str!2str',
    mahalleler: [
      { slug: 'akevler', name: 'Akevler', fullName: 'Akevler Mahallesi' },
      { slug: 'ardicli', name: 'Ardıçlı', fullName: 'Ardıçlı Mahallesi' },
      { slug: 'fatih-esenyurt', name: 'Fatih', fullName: 'Fatih Mahallesi' },
      { slug: 'guzelyurt-esenyurt', name: 'Güzelyurt', fullName: 'Güzelyurt Mahallesi' },
      { slug: 'mehtercesme', name: 'Mehterçeşme', fullName: 'Mehterçeşme Mahallesi' },
      { slug: 'pinar', name: 'Pınar', fullName: 'Pınar Mahallesi' },
      { slug: 'saadetdere', name: 'Saadetdere', fullName: 'Saadetdere Mahallesi' },
      { slug: 'yesilkent', name: 'Yeşilkent', fullName: 'Yeşilkent Mahallesi' },
      { slug: 'cumhuriyet-esenyurt', name: 'Cumhuriyet', fullName: 'Cumhuriyet Mahallesi' },
      { slug: 'namik-kemal', name: 'Namık Kemal', fullName: 'Namık Kemal Mahallesi' },
      { slug: 'ataturk-esenyurt', name: 'Atatürk', fullName: 'Atatürk Mahallesi' },
      { slug: 'karaagac-esenyurt', name: 'Karaağaç', fullName: 'Karaağaç Mahallesi' },
      { slug: 'kirac', name: 'Kıraç', fullName: 'Kıraç Mahallesi' },
      { slug: 'talatpasa', name: 'Talatpaşa', fullName: 'Talatpaşa Mahallesi' },
      { slug: 'zafer', name: 'Zafer', fullName: 'Zafer Mahallesi' },
      { slug: 'inonu', name: 'İnönü', fullName: 'İnönü Mahallesi' },
    ],
  },
  {
    slug: 'buyukcekmece-cilingir',
    name: 'Büyükçekmece',
    title: 'Büyükçekmece Çilingir',
    metaTitle: 'Büyükçekmece Çilingir | Alfa Çilingir 7/24 Acil - 0541 624 79 82',
    metaDesc: 'Büyükçekmece çilingir hizmeti. Acil kapı açma, kilit değiştirme, çelik kapı açma. 7/24 hizmet, 15 dakikada yanınızda. Hemen arayın: 0541 624 79 82',
    desc: 'Büyükçekmece\'nin tüm semtlerinde güvenilir 7/24 çilingir hizmeti.',
    longDesc: 'Alfa Çilingir olarak Büyükçekmece\'nin sahil kesiminden iç mahallelerine kadar tüm semtlerinde 7/24 profesyonel çilingir hizmeti sunuyoruz. Büyükçekmece\'de acil kapı açma, kilit değiştirme, çelik kapı açma ve oto çilingir hizmetleri için uzman ekibimiz her an hazır. Gece gündüz, hafta sonu ve tatil günleri dahil kesintisiz hizmet.',
    img: 'https://readdy.ai/api/search-image?query=Buyukcekmece%20Istanbul%20coastal%20district%2C%20lake%20view%2C%20residential%20buildings%2C%20scenic%20landscape%2C%20Turkey%2C%20beautiful%20waterfront&width=1200&height=600&seq=blp003&orientation=landscape',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48084.0!2d28.58!3d41.02!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b55f5e5e5e5e5e%3A0x0!2sB%C3%BCy%C3%BCk%C3%A7ekmece%2C+%C4%B0stanbul!5e0!3m2!1str!2str!4v1700000000012!5m2!1str!2str',
    mahalleler: [
      { slug: 'alkent', name: 'Alkent', fullName: 'Alkent Mahallesi' },
      { slug: 'gurpinar-buyukcekmece', name: 'Gürpınar', fullName: 'Gürpınar Mahallesi' },
      { slug: 'kumburgaz', name: 'Kumburgaz', fullName: 'Kumburgaz Mahallesi' },
      { slug: 'mimaroba', name: 'Mimaroba', fullName: 'Mimaroba Mahallesi' },
      { slug: 'pinartepe', name: 'Pınartepe', fullName: 'Pınartepe Mahallesi' },
      { slug: 'tepecik', name: 'Tepecik', fullName: 'Tepecik Mahallesi' },
      { slug: 'ataturk-buyukcekmece', name: 'Atatürk', fullName: 'Atatürk Mahallesi' },
      { slug: 'fatih-buyukcekmece', name: 'Fatih', fullName: 'Fatih Mahallesi' },
      { slug: 'karaagac-buyukcekmece', name: 'Karaağaç', fullName: 'Karaağaç Mahallesi' },
      { slug: 'sinanoba', name: 'Sinanoba', fullName: 'Sinanoba Mahallesi' },
      { slug: 'turkoba', name: 'Türkoba', fullName: 'Türkoba Mahallesi' },
      { slug: 'bahcelievler-buyukcekmece', name: 'Bahçelievler', fullName: 'Bahçelievler Mahallesi' },
      { slug: 'cumhuriyet-buyukcekmece', name: 'Cumhuriyet', fullName: 'Cumhuriyet Mahallesi' },
      { slug: 'kamiloba', name: 'Kamiloba', fullName: 'Kamiloba Mahallesi' },
      { slug: 'muratbey', name: 'Muratbey', fullName: 'Muratbey Mahallesi' },
      { slug: 'uckayalar', name: 'Üçkayalar', fullName: 'Üçkayalar Mahallesi' },
    ],
  },
  {
    slug: 'avcilar-cilingir',
    name: 'Avcılar',
    title: 'Avcılar Çilingir',
    metaTitle: 'Avcılar Çilingir | Alfa Çilingir 7/24 Acil - 0541 624 79 82',
    metaDesc: 'Avcılar çilingir hizmeti. Acil kapı açma, kilit değiştirme, çelik kapı açma. 7/24 hizmet, 15 dakikada yanınızda. Hemen arayın: 0541 624 79 82',
    desc: 'Avcılar\'ın tüm mahalle ve semtlerinde 7/24 hızlı ve güvenilir çilingir hizmeti.',
    longDesc: 'Alfa Çilingir olarak Avcılar\'ın tüm mahalle ve semtlerinde 7/24 profesyonel çilingir hizmeti sunuyoruz. Avcılar\'da acil kapı açma, kilit değiştirme, çelik kapı açma, oto çilingir ve kasa açma konularında uzman ekibimiz ortalama 15 dakikada adresinizde olur. Kapınız kilitli kaldıysa, anahtarınızı kaybettiyseniz veya kilit değiştirmek istiyorsanız hemen arayın.',
    img: 'https://readdy.ai/api/search-image?query=Avcilar%20Istanbul%20coastal%20residential%20district%2C%20modern%20apartment%20buildings%2C%20seaside%20neighborhood%2C%20European%20side%20Turkey%2C%20clear%20sky%20daytime%20urban%20photo&width=1200&height=600&seq=blp005&orientation=landscape',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d24042.0!2d28.72!3d40.98!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caa4a3c3c3c3c3%3A0x0!2sAvc%C4%B1lar%2C+%C4%B0stanbul!5e0!3m2!1str!2str!4v1700000000014!5m2!1str!2str',
    mahalleler: [
      { slug: 'ambarli', name: 'Ambarlı', fullName: 'Ambarlı Mahallesi' },
      { slug: 'cihangir', name: 'Cihangir', fullName: 'Cihangir Mahallesi' },
      { slug: 'denizkosk', name: 'Denizkôşkler', fullName: 'Denizkôşkler Mahallesi' },
      { slug: 'firuzkoy', name: 'Firuzköy', fullName: 'Firuzköy Mahallesi' },
      { slug: 'gumuspala', name: 'Gümüşpala', fullName: 'Gümüşpala Mahallesi' },
      { slug: 'merkez-avcilar', name: 'Merkez', fullName: 'Merkez Mahallesi' },
      { slug: 'mustafakemalpasa-avcilar', name: 'Mustafakemalpaşa', fullName: 'Mustafakemalpaşa Mahallesi' },
      { slug: 'tahtakale-avcilar', name: 'Tahtakale', fullName: 'Tahtakale Mahallesi' },
      { slug: 'umraniye-avcilar', name: 'Ümraniye', fullName: 'Ümraniye Mahallesi' },
      { slug: 'yesilkoy-avcilar', name: 'Yeşilköy', fullName: 'Yeşilköy Mahallesi' },
    ],
  },
  {
    slug: 'bahcesehir-cilingir',
    name: 'Bahçeşehir',
    title: 'Bahçeşehir Çilingir',
    metaTitle: 'Bahçeşehir Çilingir | Alfa Çilingir 7/24 Acil - 0541 624 79 82',
    metaDesc: 'Bahçeşehir çilingir hizmeti. Acil kapı açma, kilit değiştirme, çelik kapı açma. 7/24 hizmet, 15 dakikada yanınızda. Hemen arayın: 0541 624 79 82',
    desc: 'Bahçeşehir ve çevresinin tüm kısımlarında profesyonel 7/24 çilingir hizmeti.',
    longDesc: 'Alfa Çilingir olarak Bahçeşehir\'in tüm kısımlarında ve çevre mahallelerinde 7/24 profesyonel çilingir hizmeti sunuyoruz. Planlı konut bölgelerinde ve sitelerde uzman ekibimizle hızlı çözüm. Bahçeşehir\'de acil kapı açma, kilit değiştirme, çelik kapı açma ve oto çilingir hizmetleri için hemen arayın.',
    img: 'https://readdy.ai/api/search-image?query=Bahcesehir%20Istanbul%20planned%20residential%20community%2C%20modern%20houses%20villas%2C%20green%20areas%2C%20suburban%20district%2C%20Turkey%2C%20clean%20streets&width=1200&height=600&seq=blp004&orientation=landscape',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48084.0!2d28.69!3d41.06!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b55f5e5e5e5e5e%3A0x0!2sBah%C3%A7e%C5%9Fehir%2C+%C4%B0stanbul!5e0!3m2!1str!2str!4v1700000000013!5m2!1str!2str',
    mahalleler: [
      { slug: 'bahcesehir-1-kisim', name: '1. Kısım', fullName: 'Bahçeşehir 1. Kısım' },
      { slug: 'bahcesehir-2-kisim', name: '2. Kısım', fullName: 'Bahçeşehir 2. Kısım' },
      { slug: 'bahcesehir-3-kisim', name: '3. Kısım', fullName: 'Bahçeşehir 3. Kısım' },
      { slug: 'golet', name: 'Gölet', fullName: 'Gölet Mahallesi' },
      { slug: 'selale', name: 'Şelale', fullName: 'Şelale Mahallesi' },
      { slug: 'cinar-bahcesehir', name: 'Çınar', fullName: 'Çınar Mahallesi' },
      { slug: 'ispartakule', name: 'Ispartakule', fullName: 'Ispartakule Mahallesi' },
      { slug: 'kayabasi', name: 'Kayabaşı', fullName: 'Kayabaşı Mahallesi' },
      { slug: 'ziya-gokalp', name: 'Ziya Gökalp', fullName: 'Ziya Gökalp Mahallesi' },
      { slug: 'guvercintepe', name: 'Güvercintepe', fullName: 'Güvercintepe Mahallesi' },
      { slug: 'altinsehir', name: 'Altınşehir', fullName: 'Altınşehir Mahallesi' },
      { slug: 'basak', name: 'Başak', fullName: 'Başak Mahallesi' },
      { slug: 'sahintepe', name: 'Şahintepe', fullName: 'Şahintepe Mahallesi' },
      { slug: 'bahcesehir-merkez', name: 'Merkez', fullName: 'Bahçeşehir Merkez' },
    ],
  },
];

export const getBolgeBySlug = (slug: string): Bolge | undefined =>
  bolgeData.find((b) => b.slug === slug);

export const getMahalleBySlug = (bolgeSlug: string, mahalleSlug: string) => {
  const bolge = getBolgeBySlug(bolgeSlug);
  if (!bolge) return undefined;
  const mahalle = bolge.mahalleler.find((m) => m.slug === mahalleSlug);
  return mahalle ? { bolge, mahalle } : undefined;
};
